<div class="loading">
  <div [ngClass]="['loading-shape', className]">
    <div class="loading-content"><ng-content></ng-content></div>
    <div
      class="loading-ui"
      [ngClass]="{
        active: loading || failed,
        opacity: opacity
      }"
    >
      <div *ngIf="!failed" class="loading-contain">
        <ng-container *ngIf="ginni; else elseTemplate">
          <div class="loading-svg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 110">
              <defs>
                <style>
                  .cls-1 {
                    fill: none;
                    stroke: #0071bc;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-width: 6px;
                  }

                  .cls-2 {
                    fill: #c00767;
                  }
                </style>
              </defs>
              <path
                class="cls-1"
                d="M87.18,88.78a46.86,46.86,0,0,0,8.7-10.35,45.75,45.75,0,0,0,6.83-24c0-25.68-21.37-46.57-47.64-46.57S7.42,28.71,7.42,54.39C7.42,79.26,27.82,99.75,53,101a5.51,5.51,0,0,0,.71.06h6a10.25,10.25,0,0,0,3.21-.54,6.59,6.59,0,0,0,2.85-1.92c.71-.78,1.17-1.25,1.17-3.39a8,8,0,0,0-2.41-6.15,9.61,9.61,0,0,0-6.76-2.22H45.62a2.5,2.5,0,0,1-1.83-.76,2,2,0,0,1-.6-1.58c0-1.17,1.1-4.47,3.66-4.65.48,0,1,0,1.46,0,.84,0,1.7,0,2.59.08l1.6.06,2,0c1.31,0,2.59,0,3.83-.12a38.58,38.58,0,0,0,6.79-.65A24.79,24.79,0,0,0,72,76.93a15.81,15.81,0,0,0,5.44-4.47,11.57,11.57,0,0,0,2.29-7.28V50.11A10.24,10.24,0,0,0,78,44.3a13.42,13.42,0,0,0-4.67-4.17L71.06,39l-.12-.06a26.29,26.29,0,0,0-4.18-1.4c-1.39-.33-2.83-.63-4.27-.87a40.16,40.16,0,0,0-6.76-.6h-.3c-.52,0-1,0-1.57,0a34.33,34.33,0,0,0-8.43,1.4,23.75,23.75,0,0,0-9.34,4.31A10.25,10.25,0,0,0,32,50.11V63.74a6.83,6.83,0,0,0,2.33,5.06A7.66,7.66,0,0,0,39.78,71a3.07,3.07,0,0,0,2-.78"
              />
              <path
                class="cls-2"
                d="M57.08,21.82h-.51a17,17,0,0,0-4,.56A9.07,9.07,0,0,0,48,24.81,3.91,3.91,0,0,0,47,27.41v.06a2.37,2.37,0,0,0,.35,1.3,2.23,2.23,0,0,0,1.85,1.17h.07a2.82,2.82,0,0,0,1.19-.33c2-1,3.93-2,5.88-3.06a1.13,1.13,0,0,1,.53-.15h0a1.13,1.13,0,0,1,.53.15c2,1,3.92,2,5.89,3.06a2.78,2.78,0,0,0,1.19.33h.06a2.25,2.25,0,0,0,1.86-1.17,3.5,3.5,0,0,0-.72-4,9,9,0,0,0-4.54-2.43,17,17,0,0,0-4-.56"
              />
            </svg>
          </div>
        </ng-container>
        <ng-template #elseTemplate> <div class="spin"></div> </ng-template>
      </div>
      <div *ngIf="failed" class="loading-contain color-danger">
        <i class="icon-alert-triangle" aria-hidden="true"></i>
        <div class="failed-message">{{ failed }}</div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/@compartidos/components/cargando/cargando.component.html